const NOMINATIM_URL = "https://nominatim.openstreetmap.org/reverse";

// Nominatim is a free, rate-limited service; without a cap a slow answer held
// up the photo save behind it. On timeout the catch below returns coordinates.
const GEOCODE_TIMEOUT_MS = 4000;

export async function reverseGeocodeAddress(lat, lng) {
  const controller = typeof AbortController !== "undefined" ? new AbortController() : null;
  const timer = controller ? setTimeout(() => controller.abort(), GEOCODE_TIMEOUT_MS) : null;
  try {
    const resp = await fetch(
      `${NOMINATIM_URL}?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`,
      {
        headers: {
          "Accept-Language": "en",
          "User-Agent": "GameMyBiz/1.0",
        },
        signal: controller?.signal,
      },
    );

    if (!resp.ok) {
      return {
        found: false,
        address: `${lat.toFixed(6)}, ${lng.toFixed(6)}`,
      };
    }

    const data = await resp.json();
    const addr = data.address || {};

    const street =
      addr.road || addr.pedestrian || addr.footway || addr.path || "";
    const houseNumber = addr.house_number || "";
    const city =
      addr.city || addr.town || addr.village || addr.hamlet || "";
    const state = addr.state || "";
    const zip = addr.postcode || "";

    const streetWithNumber = houseNumber
      ? `${houseNumber} ${street}`
      : street;

    const parts = [streetWithNumber, city, state, zip].filter(Boolean);
    const address = parts.join(", ") || data.display_name || `${lat.toFixed(6)}, ${lng.toFixed(6)}`;

    return { found: !!street, address, street: streetWithNumber, city, state, zip };
  } catch {
    return {
      found: false,
      address: `${lat.toFixed(6)}, ${lng.toFixed(6)}`,
    };
  } finally {
    if (timer) clearTimeout(timer);
  }
}
